<template>
  <el-tabs class="tabs" v-model="activeName" @tab-click="handleClick">
    <!-- <el-tab-pane label="全部" name="zero">
      <file-list :type="0" v-if="activeName == 'zero'"></file-list>
    </el-tab-pane> -->
    <el-tab-pane label="图片" name="first">
      <file-list :type="1" v-if="activeName == 'first'"></file-list>
    </el-tab-pane>
    <el-tab-pane label="音频" name="fourth">
      <file-list :type="10" v-if="activeName == 'fourth'"></file-list>
    </el-tab-pane>
    <el-tab-pane label="视频" name="third">
      <file-list :type="11" v-if="activeName == 'third'"></file-list>
    </el-tab-pane>
    <el-tab-pane label="电子图书" name="second">
      <file-list :type="12" v-if="activeName == 'second'"></file-list>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import FileList from './file/fileList.vue'

export default {
  components: {
    FileList
  },
  data() {
    return {
      activeName: "first",
    }
  },

  methods: {
    handleClick(tab) {
      let params= {}
      this.activeName = tab.name
      if(this.$route.path == '/resources/other-resource'){
        params = { fileType: 9, isFmt: 1 }
      }else{
        params = { fileType: 9,  isAdmin: 1,isFmt: 1 }
        
      }
      this.$router.replace({
        path: this.$route.path,
        query: params
      })
    },
  },

  mounted() {
  }
}
</script>

<style lang="scss" scoped>
.tabs {
  width: 100%;
  display: flex;
  flex-direction: column;
  /deep/.el-tabs__nav-wrap {
    background: #fff;
    &::after {
      display: none;
    }
    .el-tabs__nav-scroll {
      display: flex;
      justify-content: center;
    }
  }
  /deep/.el-tabs__content {
    .file-list-wrapper {
      background: #fff;
      padding-top: 0;
    }
  }

  /deep/ .file-table{
    height: 790px;
    .el-table__body-wrapper{
      height: 630px;
    }
  }
}
</style>